import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { TouchableOpacity, StyleSheet, ViewStyle } from 'react-native';

import { useTheme } from '@/components/theme-provider';
import type { IconName } from '@/types/icons';

export interface CheckboxProps {
	status: 'checked' | 'unchecked' | 'indeterminate';
	onPress?: () => void;
	disabled?: boolean;
	style?: ViewStyle;
	testID?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
	status,
	onPress,
	disabled = false,
	style,
	testID,
}) => {
	const theme = useTheme();

	const getIconName = (): IconName => {
		switch (status) {
			case 'checked':
				return 'checkmark';
			case 'indeterminate':
				return 'remove';
			case 'unchecked':
			default:
				return 'square-outline';
		}
	};

	const getIconColor = () => {
		if (disabled) return theme.colors.outline;
		if (status === 'checked' || status === 'indeterminate') return theme.colors.primary;
		return theme.colors.outline;
	};

	return (
		<TouchableOpacity
			testID={testID}
			style={[styles.checkbox, style]}
			onPress={onPress}
			disabled={disabled}
			activeOpacity={0.7}
		>
			<Ionicons
				name={getIconName()}
				size={24}
				color={getIconColor()}
			/>
		</TouchableOpacity>
	);
};

const styles = StyleSheet.create({
	checkbox: {
		padding: 4,
	},
});
